var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { AccountAdmin, ActiveUser, Avatar, Calendar, CaretDown, CaretRight, Cart, Check, ChestClosed, ChestOpen, Chevron, ChevronDown, Clock, Cog, CustomerCare, Cycling, Dashboard, Document, DownArrow, Download, Draggable, Edit, Email, Error, Events, Exit, File, Hamburger, Help, Important, Inbox, Info, Lightening, Lock, Meals, Mindfulness, Mobile, Monitor, Options, People, Performance, Picture, PlasticRemoved, Plus, PlusFilled, Products, Refresh, Resources, Search, Share, Star, StarOutlined, Success, Tags, Tick, Trash, Trees, UpArrow, Wallet, Warning, WarningCircle, Water, WellbeingHub, Step, Yumoji, ToastError, ToastInfo, ToastSuccess, ToastWarning, World, Yudoku, Trophy, } from "./icons";
export var IconNames = [
    "account-admin",
    "active-user",
    "avatar",
    "calendar",
    "caret-down",
    "caret-right",
    "cart",
    "check",
    "chest-closed",
    "chest-open",
    "chevron",
    "chevron-down",
    "clock",
    "cog",
    "customer-care",
    "cycling",
    "dashboard",
    "document",
    "down-arrow",
    "download",
    "draggable",
    "edit",
    "email",
    "error",
    "events",
    "exit",
    "file",
    "hamburger",
    "help",
    "important",
    "inbox",
    "info",
    "lightening",
    "lock",
    "meals",
    "mindfulness",
    "mobile",
    "monitor",
    "options",
    "people",
    "performance",
    "picture",
    "plasticRemoved",
    "plus",
    "plus-filled",
    "products",
    "refresh",
    "resources",
    "search",
    "share",
    "star",
    "star-outlined",
    "success",
    "tags",
    "tick",
    "trash",
    "trees",
    "up-arrow",
    "wallet",
    "warning",
    "warning-circle",
    "water",
    "wellbeing-hub",
    "options",
    "step",
    "yumoji",
    "toast-error",
    "toast-info",
    "toast-success",
    "toast-warning",
    "trophy",
    "world",
    "yudoku",
];
export var Icon = function (props) {
    switch (props.name) {
        case "account-admin":
            return React.createElement(AccountAdmin, __assign({ title: "Account icon", height: "24", width: "24" }, props));
        case "avatar":
            return React.createElement(Avatar, __assign({ title: "Avatar icon", height: "18", width: "20" }, props));
        case "calendar":
            return React.createElement(Calendar, __assign({ title: "Calendar icon", width: "24", height: "24" }, props));
        case "cart":
            return React.createElement(Cart, __assign({ title: "Cart icon", width: "24", height: "24" }, props));
        case "caret-down":
            return React.createElement(CaretDown, __assign({ title: "Caret icon", height: "6", width: "10" }, props));
        case "caret-right":
            return React.createElement(CaretRight, __assign({ title: "Caret icon", height: "12", width: "8" }, props));
        case "check":
            return React.createElement(Check, __assign({ title: "Check icon", width: "12", height: "10" }, props));
        case "chest-closed":
            return React.createElement(ChestClosed, __assign({ title: "Closed chest icon", width: "16", height: "14" }, props));
        case "chest-open":
            return React.createElement(ChestOpen, __assign({ title: "Open chest icon" }, props));
        case "chevron":
            return (React.createElement(Chevron, __assign({ title: "Chevron icon", width: "16", height: "16" }, props)));
        case "chevron-down":
            return React.createElement(ChevronDown, __assign({ title: "Chevron icon", width: "16", height: "16" }, props));
        case "clock":
            return React.createElement(Clock, __assign({ title: "Clock icon", width: "24", height: "24" }, props));
        case "cog":
            return React.createElement(Cog, __assign({ title: "Cog icon", width: "24", height: "24" }, props));
        case "cycling":
            return React.createElement(Cycling, __assign({ title: "Cycling icon", width: "24", height: "24" }, props));
        case "customer-care":
            return React.createElement(CustomerCare, __assign({ title: "Customer care icon", width: "24", height: "24" }, props));
        case "dashboard":
            return React.createElement(Dashboard, __assign({ title: "Dashboard icon", height: "24", width: "24" }, props));
        case "document":
            return React.createElement(Document, __assign({ title: "Document icon", height: "22", width: "18" }, props));
        case "down-arrow":
            return React.createElement(DownArrow, __assign({ title: "Document icon", height: "20", width: "20" }, props));
        case "download":
            return React.createElement(Download, __assign({ title: "Download icon", height: "24", width: "24" }, props));
        case "draggable":
            return React.createElement(Draggable, __assign({ title: "Draggable icon", height: "20", width: "18" }, props));
        case "edit":
            return React.createElement(Edit, __assign({ title: "Edit icon", height: "24", width: "24" }, props));
        case "email":
            return React.createElement(Email, __assign({ title: "Email icon", height: "18", width: "24" }, props));
        case "error":
            return React.createElement(Error, __assign({ title: "Error icon", height: "32", width: "32" }, props));
        case "events":
            return React.createElement(Events, __assign({ title: "Events icon", height: "24", width: "24" }, props));
        case "exit":
            return React.createElement(Exit, __assign({ title: "Exit icon", height: "16", width: "16" }, props));
        case "file":
            return React.createElement(File, __assign({ title: "File icon", height: "24", width: "24" }, props));
        case "hamburger":
            return React.createElement(Hamburger, __assign({ title: "Hamburger icon", height: "24", width: "24" }, props));
        case "help":
            return React.createElement(Help, __assign({ height: "32", width: "32" }, props)); // no title as this covers up tooltip text
        case "inbox":
            return React.createElement(Inbox, __assign({ title: "Inbox icon", height: "24", width: "24" }, props));
        case "info":
            return React.createElement(Info, __assign({ title: "Info icon", height: "22", width: "22" }, props));
        case "lock":
            return React.createElement(Lock, __assign({ title: "Lock icon", height: "32", width: "32" }, props));
        case "lightening":
            return React.createElement(Lightening, __assign({ title: "Lightening icon", height: "24", width: "24" }, props));
        case "meals":
            return React.createElement(Meals, __assign({ title: "Meals icon", height: "24", width: "24" }, props));
        case "mindfulness":
            return React.createElement(Mindfulness, __assign({ title: "Mindfulness icon", width: "24", height: "24" }, props));
        case "mobile":
            return React.createElement(Mobile, __assign({ title: "Mobile icon", height: "24", width: "16" }, props));
        case "monitor":
            return React.createElement(Monitor, __assign({ title: "Monitor icon", height: "24", width: "24" }, props));
        case "people":
            return React.createElement(People, __assign({ title: "People icon", height: "20", width: "24" }, props));
        case "plasticRemoved":
            return React.createElement(PlasticRemoved, __assign({ title: "Plastic removed icon", height: "23", width: "24" }, props));
        case "plus":
            return React.createElement(Plus, __assign({ title: "Add icon", height: "24", width: "24" }, props));
        case "plus-filled":
            return React.createElement(PlusFilled, __assign({ title: "Add icon", height: "24", width: "24" }, props));
        case "products":
            return React.createElement(Products, __assign({ title: "Products icon", height: "24", width: "24" }, props));
        case "refresh":
            return React.createElement(Refresh, __assign({ title: "Refresh icon", height: "20", width: "20" }, props));
        case "search":
            return React.createElement(Search, __assign({ title: "Search icon", height: "16", width: "16" }, props));
        case "share":
            return React.createElement(Share, __assign({ title: "Refresh icon", height: "22", width: "20" }, props));
        case "success":
            return React.createElement(Success, __assign({ title: "Success icon", height: "32", width: "32" }, props));
        case "trees":
            return React.createElement(Trees, __assign({ title: "Trees icon", height: "24", width: "24" }, props));
        case "resources":
            return React.createElement(Resources, __assign({ title: "Resources icon", height: "24", width: "24" }, props));
        case "up-arrow":
            return React.createElement(UpArrow, __assign({ title: "Document icon", height: "20", width: "20" }, props));
        case "warning":
            return React.createElement(Warning, __assign({ title: "Warning icon", height: "32", width: "32" }, props));
        case "warning-circle":
            return React.createElement(WarningCircle, __assign({ title: "Warning icon", height: "24", width: "24" }, props));
        case "water":
            return React.createElement(Water, __assign({ title: "Water icon", height: "24", width: "24" }, props));
        case "picture":
            return React.createElement(Picture, __assign({ title: "Picture icon", height: "20", width: "20" }, props));
        case "trash":
            return React.createElement(Trash, __assign({ title: "Trash icon", height: "24", width: "24" }, props));
        case "important":
            return React.createElement(Important, __assign({ title: "Important icon", height: "24", width: "24" }, props));
        case "active-user":
            return React.createElement(ActiveUser, __assign({ title: "Active user icon", height: "16", width: "16" }, props));
        case "yumoji":
            return React.createElement(Yumoji, __assign({ title: "Yumoji icon", height: "16", width: "16" }, props));
        case "performance":
            return React.createElement(Performance, __assign({ title: "Performance icon", height: "16", width: "16" }, props));
        case "wallet":
            return React.createElement(Wallet, __assign({ title: "Wallet icon", height: "24", width: "24" }, props));
        case "wellbeing-hub":
            return React.createElement(WellbeingHub, __assign({ title: "Wellbeing hub icon", height: "24", width: "24" }, props));
        case "options":
            return React.createElement(Options, __assign({ title: "Options", height: "24", width: "24" }, props));
        case "step":
            return React.createElement(Step, __assign({ title: "Step icon", height: "24", width: "24" }, props));
        case "star":
            return React.createElement(Star, __assign({ title: "Star icon", height: "16", width: "16" }, props));
        case "star-outlined":
            return React.createElement(StarOutlined, __assign({ title: "Star icon", height: "24", width: "24" }, props));
        case "tags":
            return React.createElement(Tags, __assign({ title: "Tags icon", height: "22", width: "24" }, props));
        case "toast-error":
            return React.createElement(ToastError, __assign({ title: "Error icon", height: "48", width: "48" }, props));
        case "toast-info":
            return React.createElement(ToastInfo, __assign({ title: "Info icon", height: "48", width: "48" }, props));
        case "toast-success":
            return React.createElement(ToastSuccess, __assign({ title: "Success icon", height: "48", width: "48" }, props));
        case "toast-warning":
            return React.createElement(ToastWarning, __assign({ title: "Warning icon", height: "48", width: "48" }, props));
        case "tick":
            return React.createElement(Tick, __assign({ title: "Tick icon", height: "24", width: "24" }, props));
        case "world":
            return React.createElement(World, __assign({ title: "World icon", height: "24", width: "24" }, props));
        case "yudoku":
            return React.createElement(Yudoku, __assign({ title: "Yudoku icon", height: "24", width: "24" }, props));
        case "trophy":
            return React.createElement(Trophy, __assign({ title: "Trophy icon", height: "24", width: "24" }, props));
        default:
            return null;
    }
};
